import classnames from 'classnames';
import React, { useState } from 'react';
import { FormLabel } from '../FormLabel/FormLabel';

type RedactedInputProps = {
	label?: string;
	white?: boolean;
	required?: boolean;
	tooltip?: string;
	name: string;
};
export default function RedactedInput({
	name,
	required = false,
	label = '',
	tooltip = '',
	white = false,
}: RedactedInputProps) {
	const [isHovering, setIsHovering] = useState(false);
	return (
		<div className='flex flex-col w-full'>
			<div className='flex flex-col w-full border-0 bg-pink-900 rounded-lg relative'>
				<FormLabel
					name={name}
					label={label}
					tooltip={tooltip}
					required={required}
				/>
				<input
					value={
						isHovering
							? 'You do not have permission to view this data'
							: // Heads up this is not the default asterisk U+002A
							  // it is U+2217, this makes it center aligned.
							  // Placing this comment here incase issues arise on font changes e.c.t.
							  '∗∗∗∗∗∗∗∗∗∗∗∗'
					}
					className={classnames(
						'opacity-50 w-full px-2 pt-6 pb-2 border-0 text-base p-2 m-0 font-regular text-slate-900 rounded-lg focus:ring-lightBlue-500',
						{ 'bg-white': white },
						{ 'bg-pink-900': !white },
					)}
					name={name}
					onMouseEnter={() => setIsHovering(true)}
					onMouseLeave={() => setIsHovering(false)}
					disabled={true}
				/>
			</div>
		</div>
	);
}
